import React from 'react';

import { useGeolocationContext } from '../hooks/geolocationContext';
import { VehicleDeviceInfo } from './VehicleDeviceInfo';

import { VCIcon, DivisionIcon } from '../../../../Common/Buttons/TypeIcons';
import { P2Bold, P3Bold } from '../../../../Common/DesignSystem/Text';
import { textStyles } from './styles';

export const VehicleDeviceCardItem = ({ vehicle }) => {
	const { openMapVehiclePin, selectedVehicle } = useGeolocationContext();

	if (!vehicle) return <></>;

	const { photoUrl, displayName, vin, licensePlate, vmh, stakeholder, gpsDevice } = vehicle;

	return (
		<div
			data-testid="device-vehicle-card-item"
			className={`vehicle-card-item ${selectedVehicle?.id === vehicle.id ? 'vehicle-active' : ''}`}
			onClick={() => openMapVehiclePin(vehicle)}
		>
			<div className='vehicle-main-info'>
				<div className='vehicle-image'>
					<img src={photoUrl || 'images/vehicle/vehicle-gps-device.svg'} alt="Vehicle image" />
				</div>
				<div className='vehicle-device-info'>
					<P2Bold style={textStyles.displayName}>{displayName}</P2Bold>
					<VehicleDeviceInfo device={gpsDevice} vin={vin} licensePlate={licensePlate} />
				</div>
			</div>
			<div className='vehicle-fleet-info'>
				{Boolean(vmh) && (
					<P3Bold style={textStyles.fleet}>
						{VCIcon(vmh, 16)}
						{`${vmh.Display_Name} - ${vmh.Display_City}`}
					</P3Bold>
				)}
				{Boolean(stakeholder) && (
					<P3Bold style={textStyles.fleet}>
						{DivisionIcon(stakeholder, 16)}
						{`${stakeholder.Company} ${stakeholder.Division}`}
					</P3Bold>
				)}
			</div>
		</div>
	);
}
